/**
 * Minimal HTML hardening for admin-authored notice HTML (settings.privacyNoticeHtml).
 * We deliberately avoid a DOMPurify dependency: the content is written by Rides admins
 * (trusted staff), so we only strip the obviously executable parts — <script>, <iframe>,
 * <object>, <embed>, inline on* handlers and javascript: URLs — before rendering inside a
 * TypographyStylesProvider. If the notice ever becomes user-generated, swap this for DOMPurify.
 */
export function stripUnsafeHtml(html: string | null | undefined): string {
  if (!html) return '';
  return html
    .replace(/<\s*(script|iframe|object|embed|style|link|meta)[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '')
    .replace(/<\s*(script|iframe|object|embed|style|link|meta)[^>]*\/?>/gi, '')
    .replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/(href|src)\s*=\s*("|')\s*javascript:[^"']*\2/gi, '$1="#"');
}
